<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
      <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentAlarm">
        <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
              <h4 v-if="currentAlarm.title">{{ currentAlarm.title }}</h4>
            </div>
          </div>
          <div class="ml-10 mb-4 mt-1">
            <div class="email__actions--single flex items-baseline">
              <feather-icon icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="deleteAlarm()"></feather-icon>
              <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousMail')" />
              <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextMail')" />
            </div>
          </div>
        </div>
        <component :is="scrollbarTag" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
          <!-- LABEL ROW -->
          <div class="vx-row">
              <div class="vx-col w-full">
                  <div class="email__labels--single flex ml-10 items-center mt-2">

                          <div class="h-3 w-3 rounded-full mr-1" :class="'bg-' + labelColor(currentAlarm)"></div>
                          <span class="text-sm">{{ currentAlarm.tag | capitalize }}</span>

                  </div>
              </div>
          </div>
          <!-- /LABEL ROW -->
          <br>

          <div v-if="isSidebarActive">
            <!-- LATEST MESSAGE -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <vx-card class="px-4" >
                  <!-- MAIL HEAD -->
                  <div class="vx-row">
                    <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                      <!-- Sender Details -->
                      <div class="flex items-center">
                        <div class="flex flex-col">
                          <h5 class="mb-1">{{ currentAlarm.name }}</h5>
                        </div>
                      </div>
                      <!-- /Sender Details -->
                      <!-- Mail Time & Date -->
                      <div class="flex flex-col justify-end">
                        <span class="text-right">{{ currentAlarm.create_time | time }}</span>
                        <div class="flex justify-end mt-2">
                          <span class="text-right">{{ currentAlarm.create_time | date(true) }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- /Mail Time & Date -->
                  </div>
                  <!-- MAIL CONTENT -->
                  <div class="vx-row">
                    <div class="output ql-snow">
                      <div class="ql-editor" v-html="currentAlarm.detail"></div>
                    </div>
                  </div>
                  <div v-if="currentAlarm.link" >
                    <feather-icon icon="play" svg-classes="h-6 w-6" class="cursor-pointer ml-4" @click="goPage()"></feather-icon>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  props: {
    openAlarmId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      showThread            : false,
      activePrompt          : false,
      message               : '',
      title                 : '',
      deleteFileName        : [],
      newFileList           : [],
      fileList              : [],
      uploadPrompt          : false,
      fileMaxSize           : 15360000,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
      placeholder: '내용을 입력해주세요.'
      },
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
    openAlarmId(){
      if(this.openAlarmId != 0){
        this.$store.commit('alarm/SET_ACTIVE_ALARM', this.$store.getters['alarm/getAlarm'](this.openAlarmId))
        if (this.currentAlarm.unread == true){
          this.updateAlarm()
        }
      }
    }
  },
  computed: {
    labelColor() {
      return (label) => {
        const tags = this.$store.state.alarm.alarmTag
        var findTag = tags.find((tag) => { return tag.value == label.tag })
        if(findTag) {
          return findTag.color
        } else{
          return 'dark'
        }
      }
    },
    currentAlarm(){
      return this.$store.state.alarm.ActiveAlarm
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
  },
  methods: {
    goPage(){
      this.$router.push(this.currentAlarm.link)
    },
    deleteFiles(index){
      this.newFileList.splice(index,1)
    },
    deleteFileAlarm(name){
      this.deleteFileName = name
      this.acceptFileDelete()
    },
    acceptFileDelete(){
      this.$store.dispatch('alarm/deleteAlarmFile','id='+this.openAlarmId+'&'+'name='+this.deleteFileName).then(()=>{
        this.$vs.notify({
          color: 'danger',
          title: '삭제 완료',
          text: '선택된 파일이 삭제되었습니다.'
        })
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '삭제 실패',
          text: '선택된 파일이 없습니다.'
        })
      })
    },
    editalarm() {
      this.title = this.currentAlarm.title
      this.message = this.currentAlarm.detail
      this.activePrompt = true
    },
    clearFields() {
      this.$nextTick(() => {
        this.title = ''
        this.message = ''
      })
    },
    moveTo(to) {
      this.$emit('closeSidebar')
      this.$emit('moveTo', to)
    },
    deleteAlarm() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `공지사항 삭제`,
        text: '해당 공지사항을 삭제하시겠습니까?',
        accept: this.acceptDelete
      })
    },
    acceptDelete() {
      this.$store.dispatch('alarm/deleteAlarm', this.openAlarmId)
      .then(()=>{
        this.$emit('closeSidebar')
        this.$vs.notify({
          color: 'success',
          title: '삭제 완료',
          text: '선택된 글이 삭제되었습니다.'
        })
      })
    },
    updateAlarm() {
      this.$store.dispatch('alarm/updateAlarm', {'id':this.openAlarmId}).then(()=>{})
    },
  },
  components: {
    quillEditor,
    VuePerfectScrollbar
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
  text-align: center;
  width:100%;
  display: inline-block;
  padding: .5em .75em;
  color: #000000;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #E7E7E7;
  cursor: pointer;
  border:  solid #E7E7E7 2px;
  border-radius: .25em;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.filebox label:hover {
  background-color: #ffffff;
  border:  solid #E7E7E7 2px;
}

.filebox label:active {
  background-color: #ffffff;
  border:   solid #E7E7E7 2px;
}

.filebox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
#email-app{
    .vs-sidebar--background{
        position: absolute;
    }
    .select-all-chexkbox{
        .vs-checkbox{
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 6.3%);

      &:not(.ps) {
        overflow-y: auto;
      }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }


    .email__mails {

        .email__mail-item {
            transition: all .35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;


                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0px 3px 10px 0px #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar{
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header{
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all .35s;
        }

        .mail__attachment {
          .vs-chip--text {
            margin-left: 0;
            margin-right: 0;
          }
        }
    }
}


// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 730px;
        // max-height: 95vh;

        .vs-dialog-text {
            padding: 0;

            .scroll-area {
                max-height: 75vh;

                &:not(.ps) {
                  overflow-y: auto;
                }
            }

            .compose-mail-attachment {
              .con-input-upload {
                margin: 0;
              }
            }
        }
    }

    .con-img-upload {

    .con-input-upload {
      height: 2.5rem;
      width: 100%;
    }

        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }

    .quill-editor {
        margin-bottom: 1.5rem
    }

    .ql-editor {
        height: 150px;
    }
}

</style>
